export default {"src":"/_next/static/media/settings.aad4d966.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};